import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const RadioSelector = ({ id, name, value, onChange, checked, label, className }) => {
  return (
    <div className={classNames(className, 'RadioSelector')} >
      <label htmlFor={id} className="radio-label flex middle">
        <input
          className="radio-input hidden"
          type="radio"
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          checked={checked}
        />
        <span className="custom-radio" />
        <span className="sans-serif capitalize-first-letter">
          {label}
        </span>
      </label>
    </div>
  );
};

RadioSelector.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  label: PropTypes.string
};
